import {
  collection,
  getDocs,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Failure from '../../../core/Failure';
import { IAdmin, IConstraint } from '@leedpulse-monorepo/interfaces';
import { TOrderByDirection } from '@leedpulse-monorepo/types';

/**
 * Note : If you want to orderBy, you can use the "orderBy" opérator and "asc" or "desc" value
 * Be warned to no use "IN" with more than 20 values
 * 
 * @param constraints - The constraints to apply to the query.
 * @returns 
 */
async function getAdminsByConstraints(constraints: IConstraint[] = []) {
  try {
    const adminsRef = collection(firestore, FirestoreCollections.admins);

    const queryConstraints = constraints.map((constraint) => {
      if(constraint.op === 'orderBy') {
        return orderBy(constraint.field, constraint.value as TOrderByDirection);
      }
      return where(constraint.field, constraint.op, constraint.value);
    });

    const q = query(adminsRef, ...queryConstraints);
    const querySnapshot = await getDocs(q);

    const admins: IAdmin[] = [];
    querySnapshot.docs.forEach((doc) => {
      admins.push({ id: doc.id, ...doc.data() } as IAdmin);
    });

    return admins;
  } catch (error: any) {
    throw new GetAdminsByConstraintsFailure(error.message.toLocaleString());
  }
}

export class GetAdminsByConstraintsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getAdminsByConstraints;
